export const addMark = () => ({
  type: 'ADD_MARK',
});

export const changeMarks = (marks) => ({
  type: 'CHANGE_MARKS',
  marks,
});
